import { StyleSheet } from 'react-native';

import { colors, spacing, layout } from './theme';

/**
 * Common/shared styles for the WorkOrder app
 * Use these as base styles in component and screen stylesheets to ensure consistency.
 */

// Base container styles for screens and scroll views
export const commonContainerStyles = StyleSheet.create({
	screen: {
		flex: 1,
		backgroundColor: colors.background,
		padding: spacing.m,
	},
	scrollView: {
		flex: 1,
		backgroundColor: colors.background,
		padding: spacing.m,
	},
});

// Standard row for button containers
export const commonButtonRow = {
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginTop: spacing.m,
	marginBottom: spacing.xl,
} as const;

// Base card style
export const commonCard = {
	backgroundColor: colors.card,
	borderRadius: layout.borderRadius.medium,
	padding: spacing.s,
	marginBottom: spacing.m,
	...layout.elevation.medium,
} as const;

// Base input style
export const commonInput = {
	marginBottom: spacing.m,
	padding: spacing.s,
	width: '100%',
} as const;

// Base label style for inputs
export const commonLabel = {
	marginVertical: spacing.s,
	fontSize: 16,
	color: colors.textSecondary,
} as const;

// Empty state container
export const commonEmptyState = {
	alignItems: 'center',
	justifyContent: 'center',
	padding: spacing.xl,
} as const;

// Muted/secondary text style
export const commonMutedText = {
	color: colors.textSecondary,
} as const;
